import uuid from "uuid";

import { FETCH_DCM_LANDING_PAGES, ADD_CUSTOM_LANDING_PAGE, CLEAR_LANDING_PAGES } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchLandingPagesService } from "../../services/dcm/landingPages";
import { setAuthError } from "../app/global";

const beginFetchDcmLandingPages = (advertiserIds) => ({
  type: FETCH_DCM_LANDING_PAGES,
  status: PENDING,
  advertiserIds
});

const successDcmLandingPages = (landingPages) => ({
  type: FETCH_DCM_LANDING_PAGES,
  status: SUCCESS,
  data: landingPages
});

const failureDcmLandingPages = (err) => ({
  type: FETCH_DCM_LANDING_PAGES,
  status: FAILURE,
  err
});

export const fetchDcmLandingPages = (advertiserIds) => {
  return async (dispatch) => {
    dispatch(beginFetchDcmLandingPages(advertiserIds));

    let response;

    try {
      response = await fetchLandingPagesService(advertiserIds);

      dispatch(successDcmLandingPages(response));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      dispatch(failureDcmLandingPages(e));
    }
  };
};

export const addCustomLandingPage = (url) => ({
  type: ADD_CUSTOM_LANDING_PAGE,
  landingPage: {
    kind: "newDcmLandingPage",
    id: url, //use URL as the ID to display in select box
    url
  }
});

export const clearLandingPages = () => ({
  type: CLEAR_LANDING_PAGES
})
